import SvgIcon from '@mui/material/SvgIcon';
import { SvgIconProps } from '@mui/material/SvgIcon/SvgIcon';

export function ImageIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox='0 0 24 24'>
      <path
        d='M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2ZM8.5 13.5 11 17l3.5-4.5 4.5 6H5l3.5-5ZM15 9c0 .83-.67 1.5-1.5 1.5S12 9.83 12 9s.67-1.5 1.5-1.5S15 8.17 15 9Z'
        fill='#4caf50'
      />
    </SvgIcon>
  );
}
